module.exports = __webpack_public_path__ + "static/media/instagram.a7dc51a7.svg";